import { time } from 'core/Utils';
import { Flex, Text } from 'ui';
import { IconClock } from 'ui/Icons';

export const CampaignCountdown = ({ end }: { end?: string }) => {
  if (!end) return null;
  const timeLeft = time.daysUntil(end || '');

  const noTimeLeft = timeLeft <= 0;

  return (
    <Flex gap="xs" align={'center'}>
      <IconClock size="16px" color="#AAAAAA" />
      <Text fz="xs">{`${noTimeLeft ? '0' : timeLeft} ${timeLeft > 365 ? '+' : ''} days left`}</Text>
    </Flex>
  );
};
